// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3zk89","containerItemsCenter":"Skeleton_containerItemsCenter__1CQ4-"};